import { render, staticRenderFns } from "./VehicleTypeForm.vue?vue&type=template&id=4f53a568&"
import script from "./VehicleTypeForm.vue?vue&type=script&lang=js&"
export * from "./VehicleTypeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports